// SuccessCoach.js
import React from 'react';
import '../styles/SuccessCoach.css'; // external CSS file


const SuccessCoach = () => {
  return (
    <div className="success-coach-container">
      <h1>Success Coach</h1>
    </div>
  );
};

export default SuccessCoach;
